import React, { useContext } from 'react';

import { AuthContext } from 'app/shared/context/Auth';
import ThemeWrapper from 'app/shared/components/atoms/ThemeWrapper';
import { OrganizerSurveyModal } from 'app/shared/components/organisms/OrganizerSurveyModal';

function withOrganizerSurvey(
  PassedComponent: React.ComponentType<React.PropsWithChildren<any>>
) {
  const WrappedComponent = (props: any) => {
    const { shouldPromptForOrganizerSurvey } = useContext(AuthContext);

    return (
      <>
        {shouldPromptForOrganizerSurvey ? (
          <>
            <ThemeWrapper themeName="adminManualCSS">
              <OrganizerSurveyModal />
            </ThemeWrapper>
            <PassedComponent {...props} />
          </>
        ) : (
          <PassedComponent {...props} />
        )}
      </>
    );
  };

  return WrappedComponent;
}

export default withOrganizerSurvey;
